// import * as Stomp from "webstomp-client";
import { getToken } from "@/utils/auth";
// import SockJS from "sockjs-client";

const URL = "/api/websocket/server";
let stompClient = null;

const connect = async (subscribers) => {
  if (!stompClient || !stompClient.connected) {
    let headers = {
      Authorization: getToken(),
    };

    stompClient = Stomp.over(new SockJS(URL), {
      debug: false,
      heartbeat: { outgoing: 2000, incoming: 2000 },
    });

    return new Promise((resolve, reject) => {
      stompClient.connect(
        headers,
        () => {
          console.log("WebSocket连接成功");
          resolve(subscribeAll(subscribers));
        },
        (error) => {
          console.error("WebSocket连接失败", error);
          setTimeout(() => connect(subscribers), 2000);
          reject(error);
        }
      );
    });
  } else {
    return Promise.resolve();
  }
};

const disconnect = async () => {
  if (stompClient && stompClient.connected) {
    stompClient.disconnect();
    console.log("WebSocket断开连接");
  }
};

const subscribeAll = async (subscribers) => {
  const subscriptions = [];
  for (const { topic, topicFn } of subscribers) {
    const subscription = (await stompClient.subscribe(topic, topicFn));
    console.log("订阅：" + topic);
    subscriptions.push(subscription);
  }
  return subscriptions;
};

const unsubscribe = async (topic) => {
  if (stompClient && stompClient.connected) {
    await stompClient.unsubscribe(topic);
    console.log("取消订阅：" + topic);
  }
};

export function isConnected() {
  return stompClient && stompClient.connected;
}

export default {
  methods: {
    connect,
    disconnect,
    subscribeAll,
    unsubscribe,
  },
};
